// extracted by mini-css-extract-plugin
export default {"checkboxContent":"SingUpForm_checkboxContent__tLaL2","link":"SingUpForm_link__xZv4H"};